var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Note",
    "data-name": "Icon Note",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.629,
    height: 50.397,
    viewBox: "0 0 65.629 50.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 65.629,
    height: 50.397,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M59.837,14.265c-.631-.813-1.275-1.724-1.92-2.521-.548-.564-1.586-1.778-2.15-2.325-.772-.678-1.579-1.447-2.361-2.107A36.647,36.647,0,0,0,49.952,4.9L48.141,3.821c-.65-.3-2.216-1.064-2.857-1.351-.609-.227-2.351-.836-2.974-1.068-.687-.169-2.389-.611-3.061-.77-.685-.138-2.415-.353-3.12-.47A34.327,34.327,0,0,0,22.651,1.547c-.636.236-2.286.854-2.945,1.1l-1.882.92a39.614,39.614,0,0,0-3.613,2.11c-.538.4-1.987,1.507-2.5,1.895C11.2,8.042,9.924,9.2,9.4,9.7c-.451.492-1.664,1.86-2.094,2.332-.407.559-1.441,1.93-1.861,2.519A32.742,32.742,0,0,0,3.014,46.325a1.011,1.011,0,0,0,1.838-.844,29.987,29.987,0,0,1-2.525-15.15A32.719,32.719,0,0,1,3.649,23.7c.188-.543.835-2.168,1.022-2.714.3-.6.972-2.014,1.279-2.6.3-.5,1.227-1.959,1.523-2.466A36.4,36.4,0,0,1,9.88,12.9l1.307-1.419c.491-.432,1.673-1.507,2.155-1.93.478-.356,1.84-1.347,2.327-1.714.555-.328,1.938-1.162,2.479-1.483.546-.26,2.048-.965,2.608-1.235.6-.213,2.131-.769,2.714-.976a30.686,30.686,0,0,1,20.64,1.1c.565.283,1.986.962,2.576,1.26.521.313,1.944,1.2,2.442,1.5.545.407,1.724,1.289,2.286,1.727.7.611,1.407,1.314,2.111,1.935.457.507,1.448,1.584,1.915,2.125.572.732,1.127,1.557,1.7,2.3.35.586,1.122,1.824,1.473,2.448a29.86,29.86,0,0,1-.524,29.044,1.862,1.862,0,1,0,3.222,1.865,33.367,33.367,0,0,0-1.476-35.188",
    transform: "translate(0 0)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M55.428,48.535a3.849,3.849,0,1,0,3.849,3.849,3.849,3.849,0,0,0-3.849-3.849",
    transform: "translate(-15.035 -14.148)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M29.159,48.535a3.849,3.849,0,1,0,3.849,3.849,3.85,3.85,0,0,0-3.849-3.849",
    transform: "translate(-7.378 -14.148)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M32.416,22.356c-2.731,0-3.764,2.03-4.022,3.8-.406,2.952,1.476,7.823,1.328,11.366l1.107.184c1.624-2.583,4.354-6.79,4.834-10.7.443-2.878-.7-4.649-3.247-4.649",
    transform: "translate(-8.26 -6.517)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M59.057,22.356c-2.731,0-3.764,2.03-4.022,3.8-.406,2.952,1.476,7.823,1.328,11.366l1.107.184c1.624-2.583,4.354-6.79,4.834-10.7.443-2.878-.7-4.649-3.247-4.649",
    transform: "translate(-16.026 -6.517)",
    fill: "#ea8b49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon-note.72da6b86093c3ef6bc05170e2226d57b.svg";
export { ForwardRef as ReactComponent };